export default [
  {
    name: 'Строка',
    key: 'string'
  },
  {
    name: 'Да / Нет',
    key: 'boolean'
  },
  {
    name: 'Число',
    key: 'number'
  },
  {
    name: 'Выбор из списка',
    key: 'select'
  }
]



// WEBPACK FOOTER //
// ./src/modules/settings/components/Properties/types.js